import React from 'react';
import choxoso from "../../assets/images/choxoso.gif";
import tructiepxoso from "../../assets/images/tructiepxoso.gif";
import ok_daxosoxong from "../../assets/images/ok_daxosoxong.png";
import LookUpLotteryResults from "./LookUpLotteryResults";
import {getDateSlash} from "../../utility/DateUtils";

const LotteryResultToday = () => {

    return (
        <div>
            <div className="modulesLR moduleBrown">
                <div style={{display: "none"}}>Kết quả xổ số Hôm Nay</div>
                <div id="ketquaxosohomnay">
                    <div className="title-l">
                        <div className="title-r" style={{position: "relative"}}>
                            <a className="" href="/">
                                {"<"}
                            </a>
                            <h1 className="d-flex" style={{textAlign: "center"}}>Kết quả xổ số <span style={{fontSize: "10px"}}>Thứ hai - Ngày</span><small className="f-bold">{getDateSlash()}</small>
                            </h1>
                            <a className="" href="/">
                                >
                            </a>
                        </div>
                    </div>

                    <div className="body-l">
                        <div className="body-r">
                            <ul className="menu menulichxoso" id="ketquaxosohomnay">
                                <li><a className="hottoday_mien" href="/"
                                       title="Xổ Số Miền Nam"><strong>Kết quả xổ Số Miền Nam</strong></a>
                                    <ul>
                                        <li><a href="/"
                                               title="Kết quả xổ Số Nam Định"><span className="icon wait">Kết quả xổ Số Nam Định</span></a>
                                        </li>
                                        <li><a href="/" title="Kết quả xổ Số Đà Nẵng"><span
                                            className="icon wait">Kết quả xổ Số Đà Nẵng</span></a></li>
                                        <li><a href="/"
                                               title="Kết quả xổ Số Quảng Ngãi"><span className="icon wait">Kết quả xổ Số Quảng Ngãi</span></a>
                                        </li>
                                    </ul>
                                </li>
                                <li><a className="hottoday_mien" href="/"
                                       title="Xổ Số Miền Bắc"><strong>Kết quả xổ Số Miền Bắc</strong></a>
                                    <ul>
                                        <li><a href="/" title="Kết quả xổ Số Hà Nội"><span
                                            className="icon wait">Kết quả xổ Số Hà Nội</span></a></li>
                                    </ul>
                                </li>
                                <li><a className="hottoday_mien" href="/"
                                       title="Xổ Số Miền Trung"><strong>Kết quả xổ Số Miền Trung</strong></a>
                                    <ul>
                                        <li><a href="/"
                                               title="Kết quả xổ Số Bến Tre"><span className="icon wait">Kết quả xổ Số Bến Tre</span></a>
                                        </li>
                                        <li><a href="/"
                                               title="Kết quả xổ Số Vũng Tàu"><span className="icon wait">Kết quả xổ Số Vũng Tàu</span></a>
                                        </li>
                                        <li><a href="/"
                                               title="Kết quả xổ Số Bạc Liêu"><span className="icon wait">Kết quả xổ Số Bạc Liêu</span></a>
                                        </li>
                                    </ul>
                                </li>
                                <li><a className="hottoday_mien" href="/"
                                       title="Xổ Số Đức hạnh"><strong>Kết quả xổ Số Đức hạnh</strong></a>
                                    <ul>
                                        <li><a href="/" title="Kết quả xổ Số Đà Nẵng"><span
                                            className="icon finnish">Kết quả xổ Số Đà Nẵng</span></a></li>
                                        <li><a href="/" title="Kết quả xổ Số Long An"><span
                                            className="icon finnish">Kết quả xổ Số Long An</span></a></li>
                                        <li><a href="/" title="Kết quả xổ Số Cà Mau"><span
                                            className="icon finnish">Kết quả xổ Số Cà Mau</span></a></li>
                                    </ul>
                                </li>
                                <li><a className="hottoday_mien" href="/" title="Xổ Số Cảm ơn"><strong>Kết
                                    quả xổ Số Cảm ơn</strong></a>
                                    <ul>
                                        <li><a href="/" title="Kết quả xổ Số Bến Tre"><span
                                            className="icon wait">Kết quả xổ Số Bến Tre</span></a></li>
                                        <li><a href="/" title="Kết quả xổ Số Vũng Tàu"><span
                                            className="icon wait">Kết quả xổ Số Vũng Tàu</span></a></li>
                                        <li><a href="/" title="Kết quả xổ Số Bạc Liêu"><span
                                            className="icon wait">Kết quả xổ Số Bạc Liêu</span></a></li>
                                    </ul>
                                </li>
                                <li><a className="hottoday_mien" href="/"
                                       title="Xổ Số Miền Phía Dông"><strong>Kết quả xổ Số Miền Phía Dông</strong></a>
                                    <ul>
                                        <li><a href="/"
                                               title="Kết quả xổ Số Vĩnh Yên"><span className="icon wait">Kết quả xổ Số Vĩnh Yên</span></a>
                                        </li>
                                    </ul>
                                </li>
                                <li><a className="hottoday_mien" href="/"
                                       title="Kết quả xổ Số Điện Toán"><strong>Kết quả xổ Số Điện Toán</strong></a>
                                    <ul>
                                        <li><a href="/" title="Kết quả xổ Số 1*2*3"><span
                                            className="icon ">Kết quả xổ Số 1*2*3</span></a></li>
                                        <li><a href="/"
                                               title="Kết quả xổ Số Thần Tài 4"><span className="icon ">Kết quả xổ Số Thần Tài 4</span></a>
                                        </li>
                                        <li><a href="/"
                                               title="Kết quả xổ Số Mega 6/45"><span className="icon ">Kết quả xổ Số Mega 6/45</span></a>
                                        </li>

                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="body-l">
                    <div className="body-r">
                        <p>
                            <img alt="" height="10" src={choxoso}
                                 width="30"/>&nbsp;chờ, &nbsp;
                            <img alt="" height="8" src={tructiepxoso}
                                 width="31"/>&nbsp;đang xổ, &nbsp;
                            <img alt="" height="10" src={ok_daxosoxong}
                                 width="10"/>&nbsp;mới
                        </p>
                    </div>
                    <div className="clear"/>
                </div>
            </div>
            <div className="clear"/>
            <LookUpLotteryResults/>
        </div>
    );
}

export default LotteryResultToday;
